<template>
  <div class="resource-delivery">
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="130px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="月份">
                <el-date-picker v-model="searchForm.Month" type="month" placeholder="请选择月份" format="yyyy-MM"
                  value-format="yyyy-MM" clearable>
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="订单号">
                <el-input v-model="searchForm.orderNo" placeholder="请输入订单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单号">
                <el-input v-model="searchForm.ticketId" placeholder="请输入工单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="一级机房">
                <el-input v-model="searchForm.bizAreaName" placeholder="请输入一级机房"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="手工核对状态">
                <el-select v-model="searchForm.manualCheckStatus" clearable placeholder="请选择手工核对状态" style="width: 100%">
                  <el-option label="正常" value="1"></el-option>
                  <el-option label="异常" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="() => debouncedExport()">{{ exportButtonText }}</el-button>
                <el-button type="success" plain @click="openBatchExportDialog">批量导出</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <BatchMonthExportDialog
      :visible.sync="showBatchExportDialog"
      :loading="batchExportLoading"
      @confirm="onBatchMonthExportConfirm"
    />
    <div class="title-en">网络账单列表</div>

    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <el-button @click="openColumnsDialog">表头设置</el-button>
        </div>
        <el-table :data="faults" border stripe @selection-change="handleSelectionChange" ref="table"
          v-loading="loading">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column v-for="(column, index) in visibleColumns" :key="index" :prop="column.prop"
            :label="column.label" :width="column.width" :header-style="{
              'white-space': 'normal',
              'word-break': 'break-all',
              height: 'auto',
              'line-height': '1.2',
              padding: '8px 0',
            }" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="column.prop === 'num'">{{ scope.row.num || 0 }}</span>
              <span v-else-if="column.prop === 'realNum'">{{ scope.row.realNum || 0 }}</span>
              <el-tag v-else-if="column.prop === 'billType'" :type="scope.row.billType === '1' || scope.row.billType === 1
                ? 'success'
                : scope.row.billType === '2' || scope.row.billType === 2
                  ? 'warning'
                  : scope.row.billType === '0' || scope.row.billType === 0
                    ? 'info'
                    : 'danger'
                " size="small">
                {{
                  scope.row.billType === '1' || scope.row.billType === 1
                    ? '全额计费'
                    : scope.row.billType === '2' || scope.row.billType === 2
                      ? '打折计费'
                      : scope.row.billType === '0' || scope.row.billType === 0
                        ? '不计费'
                        : '-'
                }}
              </el-tag>
              <el-tag v-else-if="column.prop === 'status'" :type="scope.row.status === '已完成'
                ? 'success'
                : scope.row.status === '进行中'
                  ? 'warning'
                  : 'info'
                " size="small">
                {{ scope.row.status || '-' }}
              </el-tag>
              <span v-else-if="column.prop === 'endTime' || column.prop === 'startTime' || column.prop === 'olaTime'">{{
                scope.row[column.prop]
                  ? $moment(scope.row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                  : '-'
              }}</span>
              <span v-else-if="column.prop === 'opTicketid'">
                <a :href="scope.row.feedback_status === '已收单'
                  ? `https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.opTicketid}&isHistory=1`
                  : `https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.opTicketid}&isHistory=1`
                  " target="_blank">{{ scope.row.opTicketid }}</a>
              </span>
              <span v-else-if="column.prop === 'isActive'">{{
                scope.row.isActive === 1 || scope.row.isActive === '1'
                  ? '是'
                  : scope.row.isActive === 0 || scope.row.isActive === '0'
                    ? '否'
                    : '-'
              }}</span>
              <el-tag v-else-if="column.prop === 'manualCheckStatus'"
                :type="scope.row[column.prop] === '1' || scope.row[column.prop] === 1
                  ? 'success'
                  : scope.row[column.prop] === '0' || scope.row[column.prop] === 0
                    ? 'danger'
                    : 'info'"
                size="mini">
                {{
                  scope.row[column.prop] === '1' || scope.row[column.prop] === 1
                    ? '正常'
                    : scope.row[column.prop] === '0' || scope.row[column.prop] === 0
                      ? '异常'
                      : '-'
                }}
              </el-tag>
              <span v-else-if="['updateBillFactor', 'billFactor', 'manualCheckNum', 'billNum', 'dispatchNum', 'changeBillNum', 'updateBillNum', 'counts'].includes(column.prop)">
                {{ scope.row[column.prop] !== null && scope.row[column.prop] !== undefined && scope.row[column.prop] !== ''
                  ? scope.row[column.prop]
                  : '-' }}
              </span>
              <span v-else>{{ scope.row[column.prop] || '-' }}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog title="设置显示项" :visible.sync="showColumnsDialog" :append-to-body="true" width="600px"
          :close-on-click-modal="false" custom-class="columns-dialog" :modal-append-to-body="false"
          :destroy-on-close="true">
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { networkBillList } from '@/api/appManage';
import { debounce } from 'lodash';
import * as XLSX from 'xlsx';
import batchMonthExport from '@/mixins/batchMonthExport';
import {
  enumerateMonths,
  normalizeExportOptions,
  omitEmptyParams,
} from '@/utils/billMonthExport';
export default {
  name: 'NetworkBill',
  mixins: [batchMonthExport],
  data() {
    // 获取上个月的年月格式
    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    const lastMonthStr = lastMonth.getFullYear() + '-' + String(lastMonth.getMonth() + 1).padStart(2, '0');

    return {
      debouncedExport: null,
      faults: [],
      searchForm: {
        Month: lastMonthStr,
        orderNo: '',
        ticketId: '',
        bizAreaName: '',
        manualCheckStatus: '',
        page: 1,
        size: 10,
      },

      currentPage: 1,
      pageSize: 10,
      total: 0,
      showColumnsDialog: false,
      selectedColumns: [
        'TicketId',
        'otType',
        'orderNo',
        'billNum',
        'dispatchNum',
        'manualCheckStatus',
        'updateBillFactor',
        'manualCheckNum',
        'isChangeBillNum',
        'changeBillNum',
        'billFactor',
        'completer',
        'engineerName',
        'bizAreaName',
        'Month',
        'opTicketid',
      ],
      defaultSelectedColumns: [
        'TicketId',
        'otType',
        'orderNo',
        'billNum',
        'dispatchNum',
        'manualCheckStatus',
        'updateBillFactor',
        'manualCheckNum',
        'isChangeBillNum',
        'changeBillNum',
        'billFactor',
        'completer',
        'engineerName',
        'bizAreaName',
        'Month',
        'opTicketid',
      ],
      columns: [
        { prop: 'TicketId', label: 'Dcops单号（业务工单号）', width: 200 },
        { prop: 'otType', label: 'PO计费项名称', width: 150 },

        { prop: 'billNum', label: 'PO计费单数量', width: 100 },
        { prop: 'dispatchNum', label: 'PO分派单数量', width: 100 },
        { prop: 'manualCheckStatus', label: '手工核对状态', width: 120 },
        { prop: 'updateBillFactor', label: '更新的计费系数', width: 120 },
        { prop: 'manualCheckNum', label: '手动核对数量', width: 120 },
        { prop: 'isChangeBillNum', label: 'PO计费单数量是否变更(验收单)', width: 120 },
        { prop: 'changeBillNum', label: '更新PO计费单数量(验收单)', width: 100 },
        { prop: 'billFactor', label: 'PO计费单系数(0，1，0.7)', width: 100 },
        { prop: 'completer', label: '结单人', width: 100 },
        { prop: 'engineerName', label: '结单人中文名', width: 100 },
        { prop: 'bizAreaName', label: '一级机房', width: 150 },
        { prop: 'Month', label: '月份', width: 100 },
        { prop: 'opTicketid', label: '鸿云PO单号', width: 130 },
        { prop: 'orderNo', label: 'PO订单号' },

        { prop: 'ticketType', label: '网络工单类型', width: 120 },
        { prop: 'createTime', label: '派单时间', width: 150 },
        { prop: 'completeTime', label: '工单结单时间', width: 150 },
        { prop: 'billState', label: 'PO计费单状态(全额，7折，不计费等)', width: 100 },
        { prop: 'status', label: 'po状态', width: 120 },
        { prop: 'SupplyName', label: '服务商', width: 100 },
        { prop: 'isDelayCause', label: '工单判断是否超时', width: 80 },
        { prop: 'billFlowName', label: 'PO计费流程名', width: 120 },
        { prop: 'billCompleteTime', label: 'PO计费单结单', width: 150 },
        { prop: 'Assigner', label: '推送账单的推送人', width: 100 },
        { prop: 'checkCause', label: '工单判断是否超时判断原因', width: 200 },
        { prop: 'isFieldForce', label: '是否驻场结单（是/否）', width: 100 },
        { prop: 'SchemeNameCn', label: '网络流程名称（中文名）', width: 150 },
        { prop: 'isChange', label: '工单是否变更值（否/取消)(服务台人工节点)', width: 80 },
        { prop: 'dispatchTicketId', label: 'PO分派单单号', width: 130 },
        { prop: 'isChangeBillType', label: 'PO单类型是否变更', width: 130 },
        { prop: 'deviceInfoNum', label: 'PO计费类型(专项)', width: 100 },
        { prop: 'ProcessDefinitionKey', label: '网络流程标识', width: 150 },
        { prop: 'finishTime', label: '工单完成时间', width: 150 },
        { prop: 'changeInfo', label: '工单变更值(无/不计费)(服务台人工节点)', width: 150 },
        { prop: 'billTicketId', label: 'PO计费单号', width: 130 },
        { prop: 'ChangeBillType', label: '更新PO计费项名称', width: 120 },
        { prop: 'autoCheckStatus', label: '自动核对：正常/异常', width: 120 },
        { prop: 'isDispatchCheck', label: '是否派核对单，是/否', width: 100 },
        { prop: 'expectFinishTime', label: 'sla', width: 150 },
        { prop: 'isPo', label: '工单是否创建PO', width: 80 },
        { prop: 'dispatchCreateTime', label: 'PO单分派创建时间', width: 150 },
        { prop: 'DCType', label: '机房类型', width: 100 },
        { prop: 'cost_unit', label: '计费单位', width: 100 },
        { prop: 'updateOtType', label: '更新的计费项目', width: 120 },
        { prop: 'TicketId_tx_bill', label: '腾讯侧对账流程的工单号', width: 150 },
        { prop: 'isTencentCause', label: '超时是否腾讯测原因', width: 100 },
        { prop: 'isPeople', label: '自动/手工创建PO', width: 80 },
        { prop: 'dispatchDeskCreateTime', label: 'PO单分派服务台复核派单时间', width: 170 },
        { prop: 'dispatchCompleteTime', label: '分派完成时间', width: 150 },
        { prop: 'is_desk', label: '是否经过服务台审核', width: 80 },
        { prop: 'manualCheckStatus_memo', label: '手动核对备注', width: 150 },
        { prop: 'id', label: 'ID', width: 80 },
        { prop: 'delayCause', label: '超时原因', width: 150 },
        { prop: 'dispatchServiceCreateTime', label: 'PO单分派服务商派单时间', width: 170 },
        { prop: 'billDeskChangeReason', label: 'PO计费服务台变更原因', width: 170 },
        { prop: 'dispatchDeskCompleteTime', label: 'PO单分派服务台复核结单时间', width: 170 },
        { prop: 'deskChangeFile', label: '服务台审核举证', width: 150 },
        { prop: 'confirm_result', label: '确认结果：正常/异常', width: 100 },
        { prop: 'updateBillNum', label: '更新的计费数量', width: 100 },
        { prop: 'counts', label: '工单设备列表数量', width: 80 },
        { prop: 'delayCausePic', label: '超时附件', width: 150 },
        { prop: 'dispatchFlowName', label: 'PO分派流程名', width: 150 },
        { prop: 'billDeskChangeFile', label: 'PO计费服务台变更举证', width: 170 },
        { prop: 'billCreateTime', label: 'PO计费单派单时间', width: 150 },
        { prop: 'updatePic', label: '更新的图片', width: 100 },
      ],
      visibleColumns: [],
      selectedRows: [],
      machineList: [],
      loading: false,
    };
  },
  created() {
    this.visibleColumns = this.columns.filter((column) =>
      this.selectedColumns.includes(column.prop)
    );
    // 创建防抖后的导出函数（不把 click Event 传入 handleExport）
    this.debouncedExport = debounce(() => this.handleExport(), 300);
  },
  methods: {
    buildListParams(extra = {}) {
      return omitEmptyParams({
        orderNo: this.searchForm.orderNo,
        TicketId: this.searchForm.ticketId,
        bizAreaName: this.searchForm.bizAreaName,
        manualCheckStatus: this.searchForm.manualCheckStatus,
        ...extra,
      });
    },
    async fetchExportRows({ Month, Month_start, Month_end } = {}) {
      // 批量按月逐个导出，与列表查询同一套筛选条件，避免 Month_start/end 未生效时导出全表
      if (Month_start && Month_end) {
        const months = enumerateMonths(Month_start, Month_end);
        if (!months.length) {
          throw new Error('月份范围无效');
        }
        const allData = [];
        for (const month of months) {
          const params = this.buildListParams({ Month: month, export_excel: 1 });
          const response = await networkBillList(params);
          if (!response?.data) {
            throw new Error(`导出 ${month} 失败`);
          }
          if (response.data.code != null && Number(response.data.code) !== 200) {
            throw new Error(response.data.msg || `导出 ${month} 失败`);
          }
          allData.push(...(response.data.data || []));
        }
        return allData;
      }

      const params = this.buildListParams({
        Month: Month || this.searchForm.Month,
        export_excel: 1,
      });
      const response = await networkBillList(params);
      if (!response?.data) {
        throw new Error('导出失败');
      }
      if (response.data.code != null && Number(response.data.code) !== 200) {
        throw new Error(response.data.msg || '导出失败');
      }
      return response.data.data || [];
    },
    async fetchFaultData() {
      const params = this.buildListParams({
        Month: this.searchForm.Month,
        page: this.currentPage,
        size: this.pageSize,
      });

      this.loading = true;

      try {
        // 使用networkBillList接口进行查询
        const response = await networkBillList(params);
        console.log('======', response);

        if (response.data) {
          let filteredData = response.data.data || [];
          this.faults = filteredData;
          this.total = response.data.total || 0;
        }
      } catch (error) {
        console.error('请求错误:', error);
        let errorMessage = '获取数据失败';
        if (error.response && error.response.status === 422) {
          errorMessage = '请求参数格式不正确，请检查输入';
        }
        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleReset() {
      // 获取上个月的年月格式
      const lastMonth = new Date();
      lastMonth.setMonth(lastMonth.getMonth() - 1);
      const lastMonthStr = lastMonth.getFullYear() + '-' + String(lastMonth.getMonth() + 1).padStart(2, '0');

      this.searchForm = {
        Month: lastMonthStr,
        orderNo: '',
        ticketId: '',
        bizAreaName: '',
        manualCheckStatus: '',
        page: 1,
        size: 10,
      };

      this.currentPage = 1;
      this.fetchFaultData();
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchFaultData();
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    async handleExport(options) {
      const { Month_start, Month_end, forceAll } = normalizeExportOptions(options);
      const isBatchRange = Boolean(Month_start && Month_end);
      this.exportLoading = true;
      try {
        if (forceAll || this.selectedRows.length === 0) {
          // 导出全部数据（含批量月份范围）——与列表同一套筛选条件
          this.loading = true;
          const allData = await this.fetchExportRows({
            Month_start,
            Month_end,
            Month: isBatchRange ? undefined : this.searchForm.Month,
          });
          this.loading = false;
          // 转换数据格式，确保与表格显示一致
          const worksheetData = allData.map((row) => {
            const rowData = {};
            this.visibleColumns.forEach((column) => {
              if (column.prop !== 'operation') {
                // 排除操作列
                let value = row[column.prop];
                // 特殊字段处理，与表格显示保持一致
                if (
                  column.prop === 'createTime' ||
                  column.prop === 'completeTime' ||
                  column.prop === 'finishTime' ||
                  column.prop === 'expectFinishTime' ||
                  column.prop === 'billCompleteTime' ||
                  column.prop === 'dispatchCreateTime' ||
                  column.prop === 'dispatchDeskCreateTime' ||
                  column.prop === 'dispatchCompleteTime' ||
                  column.prop === 'dispatchServiceCreateTime' ||
                  column.prop === 'dispatchDeskCompleteTime' ||
                  column.prop === 'billCreateTime'
                ) {
                  value = row[column.prop]
                    ? this.$moment(row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                    : '-';
                } else if (
                  column.prop === 'isDelayCause' ||
                  column.prop === 'isChangeBillNum' ||
                  column.prop === 'isFieldForce' ||
                  column.prop === 'isChange' ||
                  column.prop === 'isChangeBillType' ||
                  column.prop === 'isDispatchCheck' ||
                  column.prop === 'isPo' ||
                  column.prop === 'isTencentCause' ||
                  column.prop === 'is_desk'
                ) {
                  value = row[column.prop] === '是' || row[column.prop] === 1 || row[column.prop] === '1' ? '是' :
                    row[column.prop] === '否' || row[column.prop] === 0 || row[column.prop] === '0' ? '否' :
                      row[column.prop] || '-';
                } else if (column.prop === 'billState') {
                  value = row[column.prop] || '-';
                } else if (column.prop === 'billFactor') {
                  value = row[column.prop] !== null && row[column.prop] !== undefined ? row[column.prop] : '-';
                } else if (column.prop === 'manualCheckStatus') {
                  value = row[column.prop] === '1' || row[column.prop] === 1
                    ? '正常'
                    : row[column.prop] === '0' || row[column.prop] === 0
                      ? '异常'
                      : '-';
                } else if (
                  column.prop === 'counts' ||
                  column.prop === 'dispatchNum' ||
                  column.prop === 'billNum' ||
                  column.prop === 'changeBillNum' ||
                  column.prop === 'manualCheckNum' ||
                  column.prop === 'deviceInfoNum'
                ) {
                  // 数量类字段特殊处理：0显示0，null/undefined显示'-'
                  value = row[column.prop] !== null && row[column.prop] !== undefined ? row[column.prop] : '-';
                } else if (
                  ['updateBillFactor', 'updateBillNum'].includes(column.prop)
                ) {
                  value = row[column.prop] !== null && row[column.prop] !== undefined && row[column.prop] !== ''
                    ? row[column.prop]
                    : '-';
                }
                rowData[column.label] = value !== null && value !== undefined ? value : '-';
              }
            });
            return rowData;
          });

          // 创建工作簿和工作表
          const worksheet = XLSX.utils.json_to_sheet(worksheetData);

          // 设置列宽
          const colWidths = {};
          this.visibleColumns.forEach((column, index) => {
            const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
            colWidths[XLSX.utils.encode_col(index)] = { wch: width };
          });
          worksheet['!cols'] = Object.values(colWidths);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, '网络账单列表');

          // 生成文件名
          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          const filename = isBatchRange
            ? `网络账单列表_${Month_start}_${Month_end}_${timestamp}.xlsx`
            : `网络账单列表_${timestamp}.xlsx`;

          // 导出文件
          XLSX.writeFile(workbook, filename);
          this.$message.success(isBatchRange
            ? `导出成功，共 ${allData.length} 条`
            : '导出成功');
        } else {
          // 导出选中数据的逻辑保持不变
          const worksheetData = this.selectedRows.map((row) => {
            const rowData = {};
            this.visibleColumns.forEach((column) => {
              if (column.prop !== 'operation') {
                // 排除操作列
                let value = row[column.prop];
                // 特殊字段处理，与表格显示保持一致
                if (
                  column.prop === 'createTime' ||
                  column.prop === 'completeTime' ||
                  column.prop === 'finishTime' ||
                  column.prop === 'expectFinishTime' ||
                  column.prop === 'billCompleteTime' ||
                  column.prop === 'dispatchCreateTime' ||
                  column.prop === 'dispatchDeskCreateTime' ||
                  column.prop === 'dispatchCompleteTime' ||
                  column.prop === 'dispatchServiceCreateTime' ||
                  column.prop === 'dispatchDeskCompleteTime' ||
                  column.prop === 'billCreateTime'
                ) {
                  value = row[column.prop]
                    ? this.$moment(row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                    : '-';
                } else if (
                  column.prop === 'isDelayCause' ||
                  column.prop === 'isChangeBillNum' ||
                  column.prop === 'isFieldForce' ||
                  column.prop === 'isChange' ||
                  column.prop === 'isChangeBillType' ||
                  column.prop === 'isDispatchCheck' ||
                  column.prop === 'isPo' ||
                  column.prop === 'isTencentCause' ||
                  column.prop === 'is_desk'
                ) {
                  value = row[column.prop] === '是' || row[column.prop] === 1 || row[column.prop] === '1' ? '是' :
                    row[column.prop] === '否' || row[column.prop] === 0 || row[column.prop] === '0' ? '否' :
                      row[column.prop] || '-';
                } else if (column.prop === 'billState') {
                  value = row[column.prop] || '-';
                } else if (column.prop === 'billFactor') {
                  value = row[column.prop] !== null && row[column.prop] !== undefined ? row[column.prop] : '-';
                } else if (column.prop === 'manualCheckStatus') {
                  value = row[column.prop] === '1' || row[column.prop] === 1
                    ? '正常'
                    : row[column.prop] === '0' || row[column.prop] === 0
                      ? '异常'
                      : '-';
                } else if (
                  column.prop === 'counts' ||
                  column.prop === 'dispatchNum' ||
                  column.prop === 'billNum' ||
                  column.prop === 'changeBillNum' ||
                  column.prop === 'manualCheckNum' ||
                  column.prop === 'deviceInfoNum'
                ) {
                  // 数量类字段特殊处理：0显示0，null/undefined显示'-'
                  value = row[column.prop] !== null && row[column.prop] !== undefined ? row[column.prop] : '-';
                }
                rowData[column.label] = value !== null && value !== undefined ? value : '-';
              }
            });
            return rowData;
          });

          const worksheet = XLSX.utils.json_to_sheet(worksheetData);

          const colWidths = {};
          this.visibleColumns.forEach((column, index) => {
            const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
            colWidths[XLSX.utils.encode_col(index)] = { wch: width };
          });
          worksheet['!cols'] = Object.values(colWidths);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, '网络账单列表');

          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          const filename = `网络账单列表_${timestamp}.xlsx`;

          XLSX.writeFile(workbook, filename);
          this.$message.success('导出成功');
        }
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error(error?.message || '导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
  watch: {
    selectedColumns(val) {
      this.selectAll = val.length === this.columns.length;
      this.isIndeterminate = val.length > 0 && val.length < this.columns.length;
    },
  },
};
</script>

<style scoped>
.resource-delivery {
  padding: 0;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 13px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.box-card {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: normal;
  word-break: break-all;
  line-height: 1.2;
  padding: 5px 0;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button+.el-button {
  margin-left: 8px;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}

::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}

::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}

/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}

::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}

/* PO单号链接样式 */
::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

::v-deep .el-table a:hover {
  color: #66b1ff;
  text-decoration: underline;
  font-weight: 500;
}
</style>
